export namespace Auth {

    export namespace Methods {

        export enum Method {
            password = 'password',
            totp = 'totp',
            whatsapp_otp = 'whatsapp_otp',
            generic_otp = 'generic_otp',
            saml = 'saml',
        }

        export enum MFAFactor {
            know = 'know',
            have = 'have',
            are = 'are',
        }

        export const methodMFAFactor: {[method in Method]: MFAFactor} = Object.freeze({
            [Method.password]: MFAFactor.know,
            [Method.totp]: MFAFactor.have,
            [Method.whatsapp_otp]: MFAFactor.have,
            [Method.generic_otp]: MFAFactor.have,
            [Method.saml]: MFAFactor.are,
        });

        export namespace SAML {

            export enum Binding {
                redirect = 'redirect',
                post = 'post',
            }

            export type SupportedBindings = {
                login: Binding[];
                logout?: Binding[];
            };

            export type AuthRequest = {
                binding: Binding;
                /** SAML Request ID */
                id: string;
            } & (
                | {
                    binding: Binding.redirect;
                    url: string;
                }
                | {
                    binding: Binding.post;
                    url: string;
                    type: string;
                    context: string;
                    relayState?: string;
                }
            );
        }
    }

}
